module.exports = __webpack_public_path__ + "img/hna.6c7147b4.png";